import { formataMoeda } from '~/src/helpers/format';

export const SELETOR_CELULA_TOTAL = '[data-total-pedidos]';
export const EVENTO_LISTAGEM_FILTRADA = 'pedidos:listagem:filtrada';

let requisicaoEmVoo = null;
let tokenDaUltimaRequisicao = 0;

export function reiniciarControleDeCorrida() {
  requisicaoEmVoo = null;
  tokenDaUltimaRequisicao = 0;
}

export function parametrosDaListagem(celula, parametrosDoEvento) {
  if (typeof parametrosDoEvento === 'string') return parametrosDoEvento;
  return celula.dataset.totalParams || '';
}

export function montarUrlDoTotal(celula, parametrosDaRequisicao) {
  const base = celula.dataset.totalUrl;
  if (!base) return null;

  const parametros = (parametrosDaRequisicao || '').replace(/^\?/, '');
  return parametros ? `${base}?${parametros}` : base;
}

export function extrairTotal(corpo) {
  if (!corpo || typeof corpo !== 'object') return null;
  if (corpo.total === null || corpo.total === undefined) return null;

  const numero = Number(corpo.total);
  return Number.isFinite(numero) ? numero : null;
}

export function aplicarValor(celula, total) {
  celula.textContent = formataMoeda(total);
  celula.removeAttribute('aria-busy');
}

export function aplicarIndisponivel(celula) {
  celula.textContent = celula.dataset.totalIndisponivel || '';
  celula.removeAttribute('aria-busy');
}

export async function buscarTotalDoRodape(opcoes = {}) {
  const documento = opcoes.documento || document;
  const janela = opcoes.janela || window;
  const requisitar = opcoes.requisitar || janela.fetch.bind(janela);

  const celula = documento.querySelector(SELETOR_CELULA_TOTAL);
  if (!celula) return;

  const url = montarUrlDoTotal(celula, parametrosDaListagem(celula, opcoes.parametros));
  if (!url) return;

  if (requisicaoEmVoo) requisicaoEmVoo.abort();
  const controlador = new AbortController();
  requisicaoEmVoo = controlador;

  tokenDaUltimaRequisicao += 1;
  const tokenDestaRequisicao = tokenDaUltimaRequisicao;

  let total = null;
  try {
    const resposta = await requisitar(url, {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
      signal: controlador.signal
    });

    if (!resposta.ok) throw new Error(`Resposta ${resposta.status} em ${url}`);

    total = extrairTotal(await resposta.json());
  } catch (erro) {
    if (erro && erro.name === 'AbortError') return;
    total = null;
  }

  if (tokenDestaRequisicao !== tokenDaUltimaRequisicao) return;

  const celulaAtual = documento.querySelector(SELETOR_CELULA_TOTAL);
  if (!celulaAtual) return;

  if (total === null) {
    aplicarIndisponivel(celulaAtual);
    return;
  }

  aplicarValor(celulaAtual, total);
}
